import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import { Login, ValidatePhone } from "@/entity/login";
import { UpLoginForm, UserVo } from "@supplier/entity";

export class LoginService extends BaseService<Login, unknown, unknown, unknown> {
    public async getUserInfo(): Promise<UserVo> {
        const { data } = await this.service.get(`${this.path}/me`);
        return data;
    }

    public async account(params: UpLoginForm): Promise<{ accessToken: string }> {
        const { data } = await this.service.post(`${this.path}/account`, params);
        return data;
    }

    public async loginPhone(params: ValidatePhone): Promise<{ accessToken: string }> {
        const { data } = await this.service.post(`${this.path}/mobile`, params);
        return data;
    }

    public async enterpriseWeChatLogin(params: { code: string; source?: string; url?: string }) {
        const { data } = await this.service.get(`${this.path}/wxw`, { params });
        return data;
    }
}

export const loginService = new LoginService("/login", request.service);
